var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('v-form',{model:{value:(_vm.validate),callback:function ($$v) {_vm.validate=$$v},expression:"validate"}},[_c('v-text-field')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }